<template>
  <a-card :bordered="false">
    <div style="padding:6px 0;">
      <a-spin :spinning="loading" tip="Loading...">
        <a-row :gutter="8" class="permission-pege-box">
          <!-- 左侧选择区域 -->
          <a-col :span="7" class="left-list-box">
            <a-button shape="circle" @click="onAdd()" icon="plus" />
            <a-button class="refresh" shape="circle" @click="onRefresh()" icon="redo" />
            <a-tree
              :treeData="permissionTreeData"
              showIcon
              defaultExpandAll
              @select="onNodeSelect"
            >
              <template slot="customMenu" slot-scope="{title, key}">
                <span @click="onNodeClick(key)">{{ title }}</span>
                <a-dropdown>
                  <a class="ant-dropdown-link" href="#">
                    <a-icon type="edit" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a href="javascript:;" @click="onAdd(key)" :disabled="!$auth('SYS_PERMISSION_ADD')">Add</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a href="javascript:;" @click="onDelete(key)" :disabled="!$auth('SYS_PERMISSION_DELETE')">Delete</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>
            </a-tree>
          </a-col>
          <!-- 右侧编辑区域 -->
          <a-col :span="17" class="right-content-box">
            <div class="hide-box" v-show="showdata"><a-icon type="file-text" /><span>Please select the menu on the left</span></div>
            <div v-show="showEdit">
              <a-form :form="myform" @submit="handleSubmit" autocomplete="off">
                <!-- 父权限名称 -->
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="Parent Permission"
                >
                  <span class="ant-form-text">
                    {{ (currentData && currentData.parent)?currentData.parent.name:'' }}
                  </span>
                </a-form-item>
                <!-- 名称 -->
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="Permission Name"
                  hasFeedback
                >
                  <a-input
                    placeholder="Permission Name"
                    v-decorator="[
                      'name',
                      {rules: [{ required: true, message: 'Please input name.' }]}
                    ]"
                  ></a-input>
                </a-form-item>
                <!-- 编码 -->
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="Permission Code"
                  hasFeedback
                >
                  <a-input
                    placeholder="Permission Name"
                    v-decorator="[
                      'code',
                      {rules: [{ required: true, message: 'Please input code.' }]}
                    ]"
                  ></a-input>
                </a-form-item>
                <!-- 序号 -->
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="Sort Number"
                  hasFeedBack
                >
                  <a-input-number
                    placeholder="Sort Number"
                    v-decorator="[
                      'sortNum',
                      {rules: [{ required: true, message: 'Please input sort number.' }]}
                    ]"
                  ></a-input-number>
                </a-form-item>
                <!-- 启用状态 -->
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="Enabled"
                  hasFeedBack
                >
                  <a-switch v-decorator="['enabledSwitch', { valuePropName: 'checked' }]" />
                </a-form-item>
                <!-- 隐藏域 -->
                <a-form-item v-show="false"><a-input v-decorator="['parentId']"/></a-form-item>
                <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
                <a-form-item
                  v-bind="buttonCol"
                >
                  <a-button type="primary" html-type="submit" :disabled="!$auth('SYS_PERMISSION_EDIT')">Save</a-button>
                  <a-button style="margin-left: 8px;" @click="onCancel">Cancel</a-button>
                </a-form-item>
              </a-form>
            </div>
          </a-col>
        </a-row>
      </a-spin>
    </div>
  </a-card>
</template>

<script>
import { queryPermissionTree, savePermission, updatePermission, deletePermission } from '@/api/api-permission'
import pick from 'lodash.pick'

export default {
  name: 'PermissionPage',
  components: {},
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      myform: this.$form.createForm(this),
      permissionData: [],
      currentData: null,
      showEdit: false,
      loading: false,
      showdata: true
    }
  },
  beforeCreate () {
    this.myform = this.$form.createForm(this)
  },
  mounted () {
    this.loadPermissionTree()
  },
  methods: {
    loadPermissionTree () {
      this.showEdit = false
      this.loading = true
      queryPermissionTree({}).then(res => {
        this.permissionData = res.data
        this.loading = false
      })
    },
    onRefresh () {
      this.loadPermissionTree()
      this.showdata = true
    },
    // 当节点选中变化时出发
    onNodeSelect (selectedKeys) {// eslint-disable-line
    },
    // 点击节点时展开编辑页面
    onNodeClick (key) {
      this.onEdit(key)
    },
    // 添加权限
    onAdd (parentId = null) {
      var currentData = { 'id': null, 'name': null, 'code': null, 'parentId': parentId, 'sortNum': 1, 'enabledSwitch': true }
      if (parentId) {
        // 获取父节点信息
        currentData.parent = this.getDataById(parentId)
      }
      this.currentData = currentData
      const formData = pick(currentData, ['id', 'name', 'code', 'parentId', 'sortNum', 'enabledSwitch'])
      // 默认获取父节点的code填写code表单，方便用户直接输入后缀就可以了
      formData.code = currentData.parent ? currentData.parent.code : null
      this.myform.setFieldsValue(formData)
      this.showEdit = true
      this.showdata = false
    },
    // 编辑权限
    onEdit (id) {
      var nodeData = this.getDataById(id)
      console.debug('nodeData', id, nodeData)
      var currentData = { 'id': id, 'name': nodeData.name, 'code': nodeData.code, 'parentId': nodeData.parentId, 'sortNum': nodeData.sortNum, 'enabledSwitch': nodeData.enabledFlag === '1' }
      if (nodeData.parentId) {
        currentData.parent = this.getDataById(nodeData.parentId)
      }
      this.currentData = currentData
      const formData = pick(currentData, ['id', 'name', 'code', 'parentId', 'sortNum', 'enabledSwitch'])
      this.myform.setFieldsValue(formData)
      this.showEdit = true
      this.showdata = false
    },
    // 删除权限
    onDelete (id) {
      const that = this
      this.$confirm({
        title: 'Are you sure delete this permission?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk () {
          // 执行删除操作
          const params = { 'ids': [id] }
          deletePermission(params).then(res => {
            if (!that.mixinProcessHasBizErrorNotification(res)) {
              that.mixinProcessSuccessNotification('Permission delete successfully !')
              that.loadPermissionTree()
            }
          })
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      // eslint-disable-next-line
      this.myform.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.myform.getFieldsValue()
        formData.enabledFlag = formData.enabledSwitch ? '1' : '0'
        // 添加
        if (formData.id === null) {
          savePermission(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Permission save successfully !')
              this.loadPermissionTree()
              this.showdata = true
            }
          })
        }
        // 修改
        if (formData.id !== null) {
          updatePermission(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Permission update successfully !')
              this.loadPermissionTree()
              this.showdata = true
            }
          })
        }
      })
    },
    // 处理点击cancel事件
    onCancel () {
      this.showEdit = false
      this.showdata = true
    },
    // 根据id获取实际的Permission数据
    getDataById (id) {
      const t1 = this.permissionData
      if (t1 && t1.length > 0) {
        for (var i = 0; i < t1.length; i++) {
          if (t1[i].id === id) {
            return t1[i]
          }
          const t2 = t1[i].subPermission
          if (t2 && t2.length > 0) {
            for (var j = 0; j < t2.length; j++) {
              if (t2[j].id === id) {
                return t2[j]
              }
              const t3 = t2[j].subPermission
              for (var k = 0; k < t3.length; k++) {
                if (t3[k].id === id) {
                  return t3[k]
                }
              }
            }
          }
        }
      }
      return null
    }
  },
  computed: {
    permissionTreeData () {
      if (this.permissionData && this.permissionData.length > 0) {
        const treeData = this.permissionData.map(d1 => {
          var t1 = { title: d1.name, key: d1.id, scopedSlots: { title: 'customMenu' } }
          if (d1.subPermission && d1.subPermission.length > 0) {
            t1.children = d1.subPermission.map(d2 => {
              var t2 = { title: d2.name, key: d2.id, scopedSlots: { title: 'customMenu' } }
              if (d2.subPermission && d2.subPermission.length > 0) {
                t2.children = d2.subPermission.map(d3 => {
                  return { title: d3.name, key: d3.id, scopedSlots: { title: 'customMenu' } }
                })
              }
              return t2
            })
          }
          return t1
        })
        return treeData
      }
      return []
    }
  }
}
</script>

<style lang="less">
.permission-pege-box{
  display: flex;
  .left-list-box{
    > ul{
      border-right: 1px #e8e8e8 solid;
      margin-top: 33px;
      > li{
        padding-bottom: 5px;
        padding-top: 0;
        span.ant-tree-switcher{
          height: 34px;
          line-height: 34px;
          i{
            font-size: 14px !important;
          }
        }
        span.ant-tree-iconEle{
          display: none;
        }
        .ant-tree-node-content-wrapper{
          width: calc(100% - 24px);
          position: relative;
          height: 34px;
          line-height: 34px;
          .ant-tree-title{
            display: flex;
            span{
              flex:1;
            }
            a{
              padding-right: 20px;
              color: #bababa;
            }
            a:hover{
              color: #1890ff;
            }
          }
        }
        .ant-tree-node-content-wrapper:hover{
          background-color: #f0faff;
        }
        .ant-tree-node-content-wrapper.ant-tree-node-selected{
          background-color: #e6f7ff;
        }
        .ant-tree-node-content-wrapper.ant-tree-node-selected:before{
          content: '';
          height: 100%;
          width: 3px;
          background: #1890ff;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      > li:nth-last-of-type(1){
        padding-bottom: 0px;
      }
    }
    .refresh{
      margin-left: 20px;
    }
  }
  .right-content-box{
    position: relative;
    .hide-box{
      position: absolute;
      width: 100%;
      text-align: center;
      top: 50%;
      margin-top: -18px;
      i{
        font-size: 36px;
        vertical-align: top;
        color: #d8d8d8;
      }
      span{
        font-size: 19px;
        line-height: 36px;
        margin-left: 15px;
        color: #cacaca;
      }
    }
  }
}
</style>
